// AUTO-GENERATED by bin/extract_legal_docs.py — do not edit by hand.
// Source: cookie_policy.md (canonical markdown)
// Generated text hash (sha256): 813b72339fa5cb59bf78d7f4a55a9c9fb2e3b835494af07c65e412d928ecc3b8

const content = `XPERT.COMPANY

operating xpert.company

Cookie Policy

Cookies, similar technologies and your choices

Version 1.1 · Effective 8 July 2026 · Issued by the Office of the Chief Legal & Compliance Officer (CLCO)

# 1. What this Policy covers

This Cookie Policy explains how Xpert.Company FZ-LLC uses cookies and similar technologies ("trackers") on xpert.company and the Xpert mobile applications. It supplements the Privacy Policy.

# 2. What trackers we use and why

Category

Purpose

Examples

Retention

Strictly necessary

Authentication, security, load balancing, CSRF protection

Supabase auth/session token, CSRF token, load-balancer cookie

Session or up to 24h

Functional

Remember language/country/currency/UI preferences; store your cookie category choices

xpert_language, xpert_country; xpert_cookie_choice (localStorage record of your consent choices)

12 months (xpert_cookie_choice persists until you clear site data)

Analytics

Understand product usage in aggregate; off until you opt in

PostHog (product analytics; stores an anonymous ID in your browser's localStorage, not a cookie; hosted in the United States)

localStorage identifier persists until you clear site data or withdraw consent

Marketing

Measure campaign effectiveness; retargeting

None active today. This category is reserved for future advertising integrations; if we add any (for example, an advertising pixel), we will name them here and they will remain off until you opt in.

N/A (no active trackers)

Session media

Enable in-call video; only when you join a session

Daily.co video tokens (transient)

Call duration

Payment and fraud prevention

Process payment and prevent fraud during checkout; only when you make a booking

Stripe (__stripe_mid, __stripe_sid) and Razorpay checkout cookies

Per processor (Stripe __stripe_mid up to 12 months; __stripe_sid ~30 minutes)

Error monitoring

Diagnose crashes and errors so we can fix them; masked session replay on error only

Sentry (US; text and media are masked)

Per Sentry default (typically 90 days)

# 3. Your choices

EU/UK/UAE/India users: non-strictly-necessary trackers are off until you opt in via the consent banner shown on your first visit. Analytics stays off unless you grant the "analytics" category.

California users: we do not currently sell or share personal information for cross-context behavioural advertising — we run no advertising trackers. We honour the browser Do Not Track signal for analytics. If we introduce advertising trackers in future, we will honour the Global Privacy Control (GPC) signal as an opt-out of sale/share and provide a "Do Not Sell or Share My Personal Information" control.

All users: you can change your choices at any time by clearing your browser's site data for xpert.company, which resets your cookie preferences and re-prompts you on your next visit. Clearing cookies will also sign you out.

# 4. Mobile identifiers

In our iOS app we follow Apple's App Tracking Transparency rules: we do not track you across other companies' apps and websites without your permission. In our Android app (planned) we will follow Google's equivalent requirements.

# 5. Updates

We may update this Policy. For material changes we will surface a banner. Version 1.1 — effective 8 July 2026.
`;

export default content;
